"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _transferActions = require("../../../redux/actions/transferActions");
var _SendReceiveTwoFactorAuthModal = _interopRequireDefault(require("./SendReceiveTwoFactorAuthModal"));
var _modalDecorator = _interopRequireDefault(require("../../../hocs/modalDecorator"));
var _modalActions = require("../../../redux/actions/modalActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  return {
    GoogleQRCode: state.user.qrCode.ManualCode,
    userName: state.user.userInfo.UserName,
    selectedAccountId: state.user.selectedAccountId
  };
};
var containerForm = (0, _reduxForm.reduxForm)({
  form: 'twoFactorAuthTransactionalModal',
  onSubmit: function onSubmit(payload, dispatch, props) {
    return dispatch((0, _transferActions.sendTwoFactorAuthCodeForTransfers)(payload.code)).then(function (response) {
      if (response && !response.Authenticated) {
        throw new _reduxForm.SubmissionError({
          _error: 'Invalid Code'
        });
      }
    }).then(function () {
      return dispatch((0, _transferActions.getTransfers)(props.selectedAccountId));
    }).then(function () {
      return true;
    });
  },
  onChange: function onChange(values, dispatch, props) {
    if (values.code && values.code.length === 6) {
      props.submit();
    }
  }
})(_SendReceiveTwoFactorAuthModal["default"]);
var container = (0, _reactRedux.connect)(mapStateToProps, null)(containerForm);
var _default = exports["default"] = (0, _modalDecorator["default"])({
  name: _modalActions.MODAL_TYPES.SEND_REQUEST_2FA
})(container);